import { Component, OnInit, Input, Output, ElementRef, HostBinding, EventEmitter, forwardRef } from '@angular/core';
import { CfCoreComponent } from '../core/core.component';
import { IconModel } from '../../models/icon/icon.model';
import { InputModel } from '../../models/input/input.model';
import { InputStylingModel } from '../../models/input/input-styling.model';
import { MenuItemModel } from '../../models/menu/menu-item.model';
import { InputTemplates } from '../../templates/input.template';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, FormControl } from '@angular/forms';
import { TemplateService } from '../../services/template-service/template.service';
export class CfInputComponent extends CfCoreComponent implements OnInit, ControlValueAccessor {
/**
 * @hidden
 */
notificationClickable = '';
/**
 * <pre>{{'{'}}
 *  display: boolean,          // Default: true.
 *  disable: boolean,          // Default: false.
 *  type: string,              // Default: text.
 *  required: boolean,         // Default: false.
 *  placeholder: string,       // Default: Input value.
 *  hint: object,              // Default: {{'{'}} text: 'max 10', align: 'end' {{'}'}}.
 *  prefix: string,            // Empty string by default.
 *  suffix: string,            // Empty string by default.
 *  dividerColor: string,      // Default goes from current theme.
 *  value: any,                // Not specified by default.
 *  maxlength: number,         // Default: 10.
 *  iconProperty: IconModel,   // Default goes with icon name: text_fields.
 *  menu: MenuModel            // Not specified by default.
 * {{'}'}}
 * </pre>
 */
public properties: InputModel;
/**
 * @hidden
 */
private val: string;
/**
 * <pre>{{'{'}}
 * // styling of the container surrounding the input
 * container: {{'{'}}
 * 		dynamic class: function() -> string, //function that returns a string of the name of the class
 * 		class: string //name of the class specified in you scss/css file
 * 	{{'}'}},
 * // styling of the input
 * input: {{'{'}}
 * 		dynamic class: function() -> string,
 * 		class: string ,
 * 		themeColor: string , // primary/accent/warn
 * {{'}'}},
 * hint: {{'{'}}
 * 		dynamic class: function() -> string,
 * 		class: string ,
 * 		themeColor: string , // primary/accent/warn
 * {{'}'}},
 * iconStyling: IconStylingModel, //refer to icon component
 * menuStyling: MenuStylingModel, //refer to menu component
 * }
 * </pre>
 */
public styling: InputStylingModel;
/**
 * <p> Type of the input if text or password.</p>
 * @param {?} value
 * @return {?}
 */
set type(value: string) { this.properties.type = value; }
/**
 * <p> If the input is required.</p>
 * @param {?} value
 * @return {?}
 */
set required(value: boolean) { this.properties.required = value; }
/**
 * <p>Placeholder of the input.</p>
 * @param {?} value
 * @return {?}
 */
set placeholder(value: string) { this.properties.placeholder = value; }
/**
 * <p> The hint under the input.</p>
 * @param {?} value
 * @return {?}
 */
set hintText(value: string) {
    if (this.properties.hint == null) { this.properties.hint = { text: '', align: 'end' }; }
    this.properties.hint.text = value;
  }
/**
 * @hidden 
 * <p> The value inside the input (double bound).</p>
 * @return {?}
 */
public get value() { return this.val; }
/**
 * <p> The icon name of the input if exists.</p>
 * @param {?} value
 * @return {?}
 */
set iconName(value: string) {
    if (this.properties.iconProperty == null) { this.properties.iconProperty = new IconModel(); }
    this.properties.iconProperty.name = value;
    this.properties.iconProperty.type = value.startsWith('fa-') ? 'fa' : 'mi';
  }
/**
 * <p> The event that will be called when the value is changed.</p>
 */
valueChange = new EventEmitter();
/**
 * @hidden
 * @param {?} value
 * @return {?}
 */
public set value(value) {
    this.val = value;
    if (this.properties) { this.properties.value = value; }
    this.valueChange.emit(this.val);
    this.onChange(value);
    this.onTouched();
  }
/**
 * @hidden 
 * It is function for creating Notification click events by using Core Component <b>notificationAction</b> event emmiter.
 * @param {?} notification 	it is json notification object
 * @return {?}
 */
cfNotificationAction(notification) { this.notificationAction.emit(notification); }
/**
 * @hidden
 * @param {?} obj
 * @return {?}
 */
writeValue(obj: any): void { if (obj) { this.value = obj; } }
/**
 * @hidden
 * @param {?} fn
 * @return {?}
 */
registerOnChange(fn: any): void { this.onChange = (value) => { Promise.resolve(null).then(() => fn(value)) }; }
/**
 * @hidden
 * @param {?} fn
 * @return {?}
 */
registerOnTouched(fn: any): void { this.onTouched = (value) => { Promise.resolve(null).then(() => fn(value)) }; }
/**
 * @hidden
 * @param {?} isDisabled
 * @return {?}
 */
setDisabledState(isDisabled: boolean): void { }
/**
 * @hidden
 */
onChange: any = () => { };
/**
 * @hidden
 */
onTouched: any = () => { };
/**
 * @hidden
 * @return {?}
 */
public resetInput() { this.value = ''; }
/**
 * @hidden
 * @param {?} elementRef
 * @param {?} templateService
 */
constructor(
public elementRef: ElementRef, /**@hidden */ templateService: TemplateService) {
    super(elementRef, templateService);
    this.properties = new InputModel();
    this.styling = new InputStylingModel();
  }
/**
 * @hidden
 * @return {?}
 */
ngOnInit() {
    super.ngOnInit();
    if (this.notificationAction.observers.length > 0) { this.notificationClickable = 'notification-clickable'; }
    this.getMyTemplate('input', InputTemplates).then(() => {
      this.mergeProperties(this.activeTemplate.property, this.properties, 'INPUT').then( sampler => {
      });
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-input',
  template: "<div *ngIf=\"_inited && properties?.display\" class=\"{{activeTemplate.style?.container?.class}} {{styling?.container?.class}} {{getDynamicClasses(activeTemplate.style?.container?.dynamicClass)}} {{getDynamicClasses(styling?.container?.dynamicClass)}}\" [ngClass]=\"'cf-input-container'\"> <md-input-container  md-tooltip=\"{{ tooltip ? tooltip.message : tooltip }}\" tooltip-position=\"{{ tooltip?.position }}\" style=\"display:inline-block;\" dividerColor=\"{{properties?.dividerColor}}\" class=\"{{activeTemplate.style?.input?.class}} {{styling?.input?.class}} {{getDynamicClasses(activeTemplate.style?.input?.dynamicClass)}} {{getDynamicClasses(styling?.input?.dynamicClass)}}\" [ngClass]=\"'cf-input'\"> <input mdInput placeholder=\"{{properties?.placeholder}}\" type=\"{{properties?.type}}\" [(ngModel)]=\"value\" attr.maxlength=\"{{properties?.maxlength}}\" [required]=\"properties?.required\" [disabled]=\"properties?.disable\"> <md-hint class=\"{{activeTemplate.style?.hint?.class}} {{styling?.hint?.class}} {{getDynamicClasses(activeTemplate.style?.hint?.dynamicClass)}} {{getDynamicClasses(styling?.hint?.dynamicClass)}}\" [ngClass]=\"'cf-input-hint'\" align=\"{{properties?.hint?.align}}\">{{properties?.hint?.text}}</md-hint> <span *ngIf=\"properties?.iconProperty == null\" md-prefix>{{properties.prefix}}</span> <span *ngIf=\"properties?.iconProperty == null\" md-suffix>{{properties.suffix}}</span> <span md-prefix *ngIf=\"properties?.iconProperty != null && properties?.iconPosition == 'left' \"> <cf-icon *ngIf=\"properties?.iconProperty != null\" [properties]=\"properties?.iconProperty\" [styling]=\"styling?.iconStyling\"></cf-icon> </span> <span md-suffix *ngIf=\"properties?.iconProperty != null && properties?.iconPosition == 'right' \"> <cf-icon *ngIf=\"properties?.iconProperty != null\" [properties]=\"properties?.iconProperty\" [styling]=\"styling?.iconStyling\"></cf-icon> </span> </md-input-container> <cf-menu style=\"display:inline-block;\" align=\"end\" #menu *ngIf=\"properties?.menu != null\" [properties]=\"properties?.menu != null?properties?.menu:'' \" [styling]=\"styling?.menuStyling\"></cf-menu> <cf-notification *ngIf=\"notification && (notification?.value || notification?.icon)\" [settings]=\"notification\" (click)=\"cfNotificationAction(notification)\"></cf-notification> </div>",
  styles: [":host { position: relative; z-index: 0; } :host /deep/ .mat-input-infix { display: flex; } :host.notification-clickable cf-notification:hover { cursor: pointer; } .mat-input-container { font-family: 'Avenir', Helvetica, sans-serif; } "],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CfInputComponent),
      multi: true
    }
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'notificationClickable': [{ type: HostBinding, args: ['class', ] },],
'properties': [{ type: Input },],
'styling': [{ type: Input },],
'type': [{ type: Input, args: ['type', ] },],
'required': [{ type: Input, args: ['required', ] },],
'placeholder': [{ type: Input, args: ['placeholder', ] },],
'hintText': [{ type: Input, args: ['hintText', ] },],
'value': [{ type: Input },],
'iconName': [{ type: Input, args: ['iconName', ] },],
'valueChange': [{ type: Output },],
};
}

function CfInputComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfInputComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfInputComponent.ctorParameters;
/** @type {?} */
CfInputComponent.propDecorators;
/**
 * @hidden
 * @type {?}
 */
CfInputComponent.prototype.notificationClickable;
/**
 * <pre>{{'{'}}
 *  display: boolean,          // Default: true.
 *  disable: boolean,          // Default: false.
 *  type: string,              // Default: text.
 *  required: boolean,         // Default: false.
 *  placeholder: string,       // Default: Input value.
 *  hint: object,              // Default: {{'{'}} text: 'max 10', align: 'end' {{'}'}}.
 *  prefix: string,            // Empty string by default.
 *  suffix: string,            // Empty string by default.
 *  dividerColor: string,      // Default goes from current theme.
 *  value: any,                // Not specified by default.
 *  maxlength: number,         // Default: 10.
 *  iconProperty: IconModel,   // Default goes with icon name: text_fields.
 *  menu: MenuModel            // Not specified by default.
 * {{'}'}}
 * </pre>
 * @type {?}
 */
CfInputComponent.prototype.properties;
/**
 * @hidden
 * @type {?}
 */
CfInputComponent.prototype.val;
/**
 * <pre>{{'{'}}
 * // styling of the container surrounding the input
 * container: {{'{'}}
 * 		dynamic class: function() -> string, //function that returns a string of the name of the class
 * 		class: string //name of the class specified in you scss/css file
 * 	{{'}'}},
 * // styling of the input
 * input: {{'{'}}
 * 		dynamic class: function() -> string,
 * 		class: string ,
 * 		themeColor: string , // primary/accent/warn
 * {{'}'}},
 * hint: {{'{'}}
 * 		dynamic class: function() -> string,
 * 		class: string ,
 * 		themeColor: string , // primary/accent/warn
 * {{'}'}},
 * iconStyling: IconStylingModel, //refer to icon component
 * menuStyling: MenuStylingModel, //refer to menu component
 * }
 * </pre>
 * @type {?}
 */
CfInputComponent.prototype.styling;
/**
 * <p> The event that will be called when the value is changed.</p>
 * @type {?}
 */
CfInputComponent.prototype.valueChange;
/**
 * @hidden
 * @type {?}
 */
CfInputComponent.prototype.onChange;
/**
 * @hidden
 * @type {?}
 */
CfInputComponent.prototype.onTouched;
/**
 * @hidden
 * @type {?}
 */
CfInputComponent.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
